import * as Sentry from '@sentry/browser';

Sentry.init({
    dsn: 'https://c1ad7bdd9baf427189d1abe67c15065d@o168168.ingest.sentry.io/1242882',
    autoSessionTracking: false,
    integrations: [],
});

import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

import 'bootstrap';

import Lang from 'lang.js';

import messages from '../lang/messages.json';
import { initializeMatomo } from './support/p';
window.lang = new Lang({
    messages: messages,
});

import('devbridge-autocomplete');
import 'bootstrap-select/dist/js/bootstrap-select.min.js';
import 'bootstrap-select/dist/js/i18n/defaults-de_DE.min.js';
import 'bootstrap-select/dist/js/i18n/defaults-fr_FR.min.js';
import 'bootstrap-select/dist/js/i18n/defaults-nl_NL.min.js';

import {
    checkOptionalEventListeners,
    initializeGeneralEventListeners,
} from './app/eventListeners';
import { mLayout } from './metronic/app/base/layout';
import { mApp } from './metronic/framework/base/app';
import { mUtil } from './metronic/framework/base/util';

window.mUtil = mUtil;
window.mApp = mApp;

document.addEventListener('DOMContentLoaded', () => {
    mUtil.init();
    mApp.init();
    mLayout.init();

    initializeGeneralEventListeners();
    checkOptionalEventListeners();
});

initializeMatomo();
